/** Gender type - matches the Gender type from @complexcare/orchestra Defined locally to avoid circular dependency */
export type Gender = 'Male' | 'Female' | 'Other' | 'Unknown' | 'Prefer not to say';

/**
 * Intervention type - matches the InterventionType from @complexcare/orchestra Defined locally to avoid circular
 * dependency
 */
export type InterventionType = 'IHA' | 'VHV' | 'AHV';

/**
 * Maps a gender string value to the Gender enum Normalizes input by trimming and converting to lowercase
 *
 * @example
 *   mapGender('Male'); // Returns 'Male'
 *   mapGender('FEMALE'); // Returns 'Female'
 *   mapGender('other'); // Returns 'Other'
 *   mapGender(''); // Returns 'Unknown'
 *
 * @param value - The gender string to map (e.g., 'male', 'female', 'other', 'prefer not to say')
 * @returns Normalized gender enum value
 */
export function mapGender(value?: string): Gender {
  const normalized = (value ?? '').trim().toLowerCase();
  if (normalized === 'male') return 'Male';
  if (normalized === 'female') return 'Female';
  if (normalized === 'other') return 'Other';
  if (normalized === 'prefer not to say') return 'Prefer not to say';
  return 'Unknown';
}

/**
 * Maps an intervention type code to the InterventionType enum Converts numeric codes to their string equivalents
 *
 * @example
 *   mapInterventionType(1); // Returns 'IHA'
 *   mapInterventionType(2); // Returns 'VHV'
 *   mapInterventionType(3); // Returns 'AHV'
 *   mapInterventionType(null); // Returns 'IHA'
 *
 * @param value - The intervention type code (1=IHA, 2=VHV, 3=AHV)
 * @returns Mapped intervention type string, defaults to 'IHA'
 */
export function mapInterventionType(value?: number): InterventionType {
  switch (value) {
    case 1:
      return 'IHA';
    case 2:
      return 'VHV';
    case 3:
      return 'AHV';
    default:
      return 'IHA';
  }
}
